import { Routes, RouterModule } from '@angular/router';
import { ChildrenListComponent } from './booking/1-children-list/ChildrenListComponent'
const appRoutes: Routes = [
	{ path: 'booking/students', component: ChildrenListComponent},
	{ path: '', redirectTo: 'booking/students', pathMatch: 'full' }
];

export const appRoutingProviders: any[] = [

];

export const routing = RouterModule.forRoot(appRoutes);


// WEBPACK FOOTER //
// ./src/holiday/parent/AppRouting.ts